<app-title-percentage
  [title]="title"
  [percentage]="(praticaProgressService.progress$ | async)?.applicant"
>
</app-title-percentage>
<!--
<p *ngIf="showCrifError" class="warn-text">
  Attenzione! Non è stato possibile recuperare dalle banche dati esterne il dato evidenziato. Contattare il Centro di
  Competenza Crescitalia per le opportune verifiche.</p> -->

<smart-form
  #applicantForms
  [fields]="fields1"
  [validationStrategy]="'blur'"
  class="crif-form"
></smart-form>
<app-address-form
  *ngIf="
    personaGiuridica?.location &&
    !(type === 'AML' && target === 'professionisti')
  "
  [fieldsToBeShown]="sedeLegaleLocationFieldsToBeShown"
  [formData]="personaGiuridica?.location"
  [title]="target === 'imprese' ? 'Indirizzo sede legale' : ''"
  [groupName]="target === 'imprese' ? 'sede legale' : ''"
>
</app-address-form>

<div *ngFor="let section of sections" style="margin-top: 2rem">
  <ng-container *ngIf="section.type !== 'ADDRESS'; else elseblock">
    <h2>{{ section.title }}</h2>
    <p [innerHTML]="section.description"></p>
    <smart-form #extensionsForms [fields]="section.fields || []"></smart-form>
  </ng-container>

  <ng-template #elseblock>
    <mat-accordion>
      <div style="margin-bottom: 2rem">
        <mat-expansion-panel
          (opened)="setPanelState(true)"
          (closed)="setPanelState(false)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title style="color: #025268">{{
              section.title
            }}</mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngFor="let a of section.fields">
            <app-address-form
              #extensionsAddressForms
              title=""
              [groupName]="a[0].label"
              [fieldsToBeShown]="
                extensionsLocationFieldsToBeShown[a[0].formControlName]
              "
              [formData]="personaGiuridica?.extension?.[a[0].formControlName]"
            >
            </app-address-form>
          </ng-container>
        </mat-expansion-panel>
      </div>
    </mat-accordion>
  </ng-template>
</div>

<app-shareholders-table
  *ngIf="type === 'AML' && target === 'imprese'"
  [personaGiuridica]="personaGiuridica"
  (onEditShareholders)="onEditShareholders($event)"
></app-shareholders-table>

<!-- <section *ngIf="taxDataIsVisible">
  <h2>Dati Fiscali</h2>
  <app-tax-data [idPratica]="idPratica" [personaGiuridicaContabilita]="personaGiuridica?.tipoContabilita"
    (contabilitaChange)="updateContabilita($event)">
  </app-tax-data>
</section> -->

<div style="margin-top: 4rem">
  <smart-form
    #applicantForms
    [fields]="fields2"
    [validationStrategy]="'blur'"
  ></smart-form>
</div>

<section *ngIf="type === 'FIN'">
  <h2>Immobili</h2>
  <p *ngIf="!isImmobiliValid" style="color: red">
    In caso di selezione dell'opzione "Proprietà" per il campo situazione
    abitativa è obbligatorio inserire almeno un'immobile.
  </p>
  <app-property-table
    [properties]="properties"
    (selectedProperty)="openPropertyForm($event)"
    (onDeleteProperty)="onDeleteProperty($event)"
  ></app-property-table>
  <div class="margin-top-rounded-buttons">
    <button
      mat-flat-button
      color="accent"
      class="squared-button"
      [disabled]="praticaProgressService.isFrozenOrConfermata"
      aria-label="Aggiungi nuovo immobile"
      matTooltip="Aggiungi nuovo immobile"
      (click)="openPropertyForm()"
    >
      +
    </button>
  </div>
</section>
